// extracted by mini-css-extract-plugin
export default {"fixedHeader":"Header_fixedHeader__AuEwV","wrapperForFixed":"Header_wrapperForFixed__vzvBi","header":"Header_header__Bbde6"};